import React from "react";

import { Box, Button, CircularProgress, Stack, useTheme } from "@mui/material";

import { getButtonStyles } from "src/shell/styles/themeUtils";

interface SubmitButtonProps {
  canSubmit: boolean;
  isSubmitting: boolean;
}

export function SubmitButton({
  canSubmit,
  isSubmitting,
}: SubmitButtonProps): React.ReactElement {
  const theme = useTheme();
  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
      <Button
        type="submit"
        variant="contained"
        disabled={!canSubmit}
        sx={{
          ...getButtonStyles(theme, "contained"),
          minWidth: { xs: "100%", sm: "200px" },
          "&:active": { transform: "scale(0.98)" },
        }}
      >
        {isSubmitting ? (
          <Stack direction="row" spacing={1} alignItems="center">
            <CircularProgress size={18} color="inherit" />
            <span>Creating...</span>
          </Stack>
        ) : (
          "Create Project"
        )}
      </Button>
    </Box>
  );
}
